import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { TextField, Box, Button } from '@mui/material';

const useStyles = () => ({
  root: {
    minWidth: '300px',
  },
});

const BranchesFilters = function BranchesFilters({
  onChangeFilters,
  defaultValues,
}) {
  const intl = useIntl();
  const classes = useStyles();

  const [searchQuery, setSearchQuery] = useState(
    defaultValues?.searchBox || ''
  );

  useEffect(() => {
    setSearchQuery(defaultValues?.searchBox || '');
  }, [defaultValues]);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  return (
    <div style={classes.root}>
      <TextField
        fullWidth
        variant="outlined"
        label={intl.messages.SEARCH}
        value={searchQuery}
        onChange={handleSearchChange}
        size="small"
        margin="normal"
      />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          position: "sticky",
          bottom: 0,
          pt: "16px"
        }}>
        <Button
          id="confirm-filters-btn"
          size="large"
          onClick={() => {
            onChangeFilters({ searchBox: searchQuery });
          }}
        >
          {intl.messages.CONFIRM}
        </Button>
      </Box>
    </div>
  );
};

BranchesFilters.propTypes = {
  onChangeFilters: PropTypes.func.isRequired,
  defaultValues: PropTypes.object,
};

BranchesFilters.defaultProps = {
  defaultValues: {
    searchBox: '',
  },
};

export default BranchesFilters;
